<template>
  <div class="set-title">
    <el-dialog
        title="发送"
        :visible="true"
        @close="handleClose"
        width="460px"
    >
      <el-form label-suffix="：" size="small" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
        <el-form-item label="国际物流单号" prop="internationalLogisticsNumber">
          <el-input placeholder="请输入国际物流单号" v-model="ruleForm.internationalLogisticsNumber"></el-input>
        </el-form-item>
        <el-form-item label="抛重" prop="throwWeight">
          <el-input-number placeholder="请输入抛重" :controls="false" :min="0" v-model="ruleForm.throwWeight" ></el-input-number>
        </el-form-item>
        <el-form-item label="实重" prop="realWeight">
          <el-input-number :controls="false" :min="0" placeholder="请输入实重" v-model="ruleForm.realWeight" ></el-input-number>
        </el-form-item>
        <el-form-item label="包装尺寸(长)" prop="length">
          <el-input-number placeholder="请输入包装尺寸(长)" :min="0" v-model="ruleForm.length" :controls="false" >
          </el-input-number>
        </el-form-item>
        <el-form-item label="包装尺寸(宽)" prop="width">
          <el-input-number placeholder="请输入包装尺寸(宽)" :min="0" v-model="ruleForm.width" :controls="false" ></el-input-number>
        </el-form-item>
        <el-form-item label="包装尺寸(高)" prop="height">
          <el-input-number placeholder="请输入包装尺寸(高)" :min="0" v-model="ruleForm.height" :controls="false" ></el-input-number>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button size="small" type="info" @click="handleClose">取消</el-button>
        <el-button size="small" type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "BoxGg",
  props: {
    row: {
      type: Object,
      default: () =>({})
    },
  },
  data(){
    return{
      ruleForm: {
        internationalLogisticsNumber: '',
        throwWeight: undefined,
        realWeight: undefined,
        length: undefined,
        width: undefined,
        height: undefined,
      },
      rules: {
        internationalLogisticsNumber: [
          { required: true, message: '请输入国际物流单号', trigger: 'blur' }
        ],
        throwWeight: [
          { required: true, message: '请输入抛重', trigger: 'blur' }
        ],
        realWeight: [
          { required: true, message: '请输入实重', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    // if(this.title !== '新增会员等级'){
    //   this.ruleForm = {
    //     ...this.ruleForm,
    //     ...this.row
    //   }
    // }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let params = {
            ...this.ruleForm,
            orderId: this.row.id,
          }
          const res = await this.$http.post("order/sendInternationalLogistics",params)
          console.log('res===',res)
          if(res.data.code === 200){
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            this.$options.confirm(true)
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose () {
      this.$options.cancel('cancel')
    }
  }
}
</script>

<style scoped lang="less">
.set-title {
  ::v-deep .el-input-number--small {
    width: 100%;
  }
  ::v-deep .el-dialog__header {
    text-align: center;
  }
  ::v-deep .el-dialog__body{
    padding-top: 10px;
  }
  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
  }
  ::v-deep .el-input-number--medium {
    width: 100%;
  }
  ::v-deep .el-input-number.is-without-controls .el-input__inner {
    text-align: left;
  }
}
</style>
